<app-nav></app-nav>
<app-top-header [showMonthControl]="false" [pageTitle]="'page.helpUserManual'"></app-top-header>

<div class="ParentSectionSection_Components_HTally">
  <div class="Body_ParentSectionSection_Components_HTally">
    <div class="InnerPart_Body_Renter_Htally">
      <div class="Parent_ActivityList_Dashboard TabsSection">
        <div class="InnerBodyOfComponents help-manual-page">
          <div class="TabsHeader">
            <div class="RemainActivityList_Tab_Button">
              <button type="button" (click)="selectTab('manual')" [class.active]="activeTab === 'manual'">
                {{ 'help.userManualTab' | t:'User Manual' }}<span></span>
              </button>
              <button type="button" (click)="selectTab('videos')" [class.active]="activeTab === 'videos'">
                {{ 'help.videoTutorialsTab' | t:'Video tutorials' }}<span></span>
              </button>
              <button type="button" (click)="selectTab('faq')" [class.active]="activeTab === 'faq'">
                {{ 'help.faqTab' | t:'FAQ' }}<span></span>
              </button>
            </div>
          </div>

          <div *ngIf="activeTab === 'manual'" class="RemainActivityList_tab_content help-tab-content">
            <object class="manual-pdf-viewer" [data]="manualPdfResourceUrl" type="application/pdf">
              <iframe class="manual-pdf-viewer" [src]="manualPdfResourceUrl" title="HTally User Manual"></iframe>
            </object>
          </div>

          <div *ngIf="activeTab === 'videos'" class="RemainActivityList_tab_content help-tab-content coming-soon-panel">
            {{ 'help.comingSoon' | t:'Comming soon' }}
          </div>

          <div *ngIf="activeTab === 'faq'" class="RemainActivityList_tab_content help-tab-content coming-soon-panel">
            {{ 'help.comingSoon' | t:'Comming soon' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
